import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  OtherAssets = 'OtherAssets',
}

export const queryKeys = {
  otherAssets: (clientId: string) => [QueryFeature.Profile, QueryKey.OtherAssets, clientId],
};
